import { Injectable } from '@angular/core';

import { ObrigacaoNavigationService } from "../../shared/obrigacao-navigation.service";
import { Obrigacoeservice } from "../../shared/obrigacao.service";
import { AutoCompleteService } from "../../../../shared/components/autocomplete/autocomplete.service";
import { obrigacaoTiposStorage } from "./data.service";
import { obrigacoesStorage } from "../../shared/data.service";

@Injectable()
export class ObrigacaoTipoService {

  constructor(
    private _obrigacaoNavigationService: ObrigacaoNavigationService,
    private _obrigacoeservice: Obrigacoeservice,

    private _autocompleteService: AutoCompleteService
  ) { }

  //session
  setSessionStorage(item: any) {
    var object: string = JSON.stringify(item);
    sessionStorage.setItem(obrigacaoTiposStorage + '-new', object);
  }

  getSessionStorage() {
    var item: string = sessionStorage.getItem(obrigacaoTiposStorage + "-new");
    return JSON.parse(item);
  }

  clearSessionStorage() {
    sessionStorage.removeItem(obrigacaoTiposStorage + "-new");
  }

  returnToOtherForm(otherForm: string, Response: any) {
    if(Response) {
      var otherFormObject: any;

      if (otherForm === obrigacoesStorage) {
        otherFormObject = this._obrigacoeservice.getSessionStorage();
        otherFormObject.tipoObrigacao = Response;
        this._obrigacoeservice.setSessionStorage(otherFormObject);
      }
    }

    this._autocompleteService.clearSessionStorage(obrigacaoTiposStorage);

    if (otherForm === obrigacoesStorage) {
      otherFormObject = this._obrigacoeservice.getSessionStorage();
      if (otherFormObject.id) {
        this._obrigacaoNavigationService.goToEdit(otherFormObject.id);
      } else {
        this._obrigacaoNavigationService.goToNew();
      }
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacao-tipos/shared/obrigacao-tipo.service.ts
 **/